// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";

// Material Kit 2 PRO React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "examples/Cards/BlogCards/CenteredBlogCard";

import getStartedImg from "../../../assets/images/content-5.jpg";

function Information() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="house"
                    title="Find a House to Rent or Buy"
                    description="Submit a request, and we'll assist you in finding the ideal rental property or home to purchase, tailored to your lifestyle and needs in East Africa."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="directions_car"
                    title="Rent or Buy a Car with Driver"
                    description="Book a ride or purchase a vehicle with ease. We provide comfortable options and professional drivers to ensure a smooth and reliable journey."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="terrain"
                    title="Purchase Land or Plots"
                    description="Planning to invest in land? Share your preferences, and we'll help you identify the perfect plot for your goals and budget."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="cleaning_services"
                    title="Hire a Maid"
                    description="Need a reliable and multilingual maid? We connect you with experienced professionals ready to assist during your stay."
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={getStartedImg}
              title="Get the Best Out of Your Stay"
              description="Explore how our tailored services—rental homes, cars with drivers, land purchases, and maid hiring—can make your time in East Africa hassle-free and memorable."
              action={{
                type: "internal",
                route: "/booking",
                color: "primary",
                label: "Get Started Here",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
